export const DATUM_OPTIONS = [
  { Code: 'Coor', Description: 'Coordinates' },
  { Code: 'Deg', Description: 'Degrees' },
];

export const DICT_SELECT_PROPS = {
  optionValue: 'Code',
  optionLabel: 'Description',
  showLabelOnly: false,
};

export const DEFAULT_VALUES = {
  Latitude: '',
  Longitude: '',
  UncertaintyDistance: '',
  Datum: '',
  CoordinateDT: null,
  Altitude: '',
  AltitudeRefPoint: '',
  CellID: '',
  SectorID: '',
  Speed: '',
  AltitudeUnitMeasure: '',
  SpeedUnitMeasure: '',
};

export const DEFAULT_CENTER = { lat: 30.39, lng: -91.07 };
